<template>
    <div :title="$t('sectionModeloMensagem.cliqueEnviarModelo')">
        <button v-if="!primeiraMensagem" class="btn-text" type="button" @click="AbrirModal()">
            <i class="fas fa-comments"></i>
        </button>
        <button v-else class="btn btn-info" @click="AbrirModal()"> 
            {{ $t("sectionModeloMensagem.cliqueEnviarModelo") }}
        </button>
        <b-modal v-model="abrir" :title="$t('sectionModeloMensagem.enviarModelo')" size="lg" hide-footer>

            <div v-if="loading" class="loading-container">
                <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
            </div>
            <div v-else>
                <div class="row">
                    <b-table :hover="true" responsive :items="itens" :fields="fields" striped :per-page="itensPorPagina"
                        show-empty :empty-text="$t('sectionModalArchive.fileNotFound')" select-mode="single" selectable
                        selected-variant="success" @row-clicked="selecionarRegistro" class="col-sm-8">
                        <template v-slot:empty="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                        <template v-slot:cell(categoria)="data">
                            <div class="center">
                                <span>{{
                                    ObterNomeCategoria(data.item.categoria)
                                }}</span>
                            </div>
                        </template>
                    </b-table>
                    <div class="col-sm-4" v-if="registroSelecionado">
                        <div class="card">

                            <header class="card-header">
                                <strong class="align-self-center">
                                    {{ $t("sectionModeloMensagem.previa") }}
                                </strong>

                            </header>
                            <button class="btn btn-success" @click="EnviarModelo()">
                                {{ $t("btEnviar") }}
                            </button>
                            <div class="previa">

                                <div class="chat-bubble">
                                    <strong v-if="viewModel.cabecalho == 1">{{ viewModel.textoCabecalho }}</strong>
                                    <div v-if="viewModel.cabecalho == 2 && viewModel.tipoMidia == 'IMAGE'"
                                        class="chat-image text-center">
                                        <i v-if="!arquivoId" class="fas fa-image"></i>
                                        <img v-else
                                            :src="!arquivoId ? imageUrl : $store.getters.baseURL + 'arquivo/obter/' + arquivoId">
                                    </div>
                                    <div v-if="viewModel.cabecalho == 2 && viewModel.tipoMidia == 'VIDEO'"
                                        class="chat-image text-center">
                                        <i v-if="!arquivoId" class="fas fa-video "></i>
                                        <video v-else controls preload="none">
                                            <source
                                                :src="!arquivoId ? imageUrl : $store.getters.baseURL + 'arquivo/obter/' + arquivoId"
                                                type="video/mp4" />
                                        </video>
                                    </div>
                                    <p class="chat-text">{{ viewModel.corpo }}</p>
                                    <p class="chat-bubble-footer">{{ viewModel.rodape }}</p>
                                    <p class="chat-time">{{ horaAtual }}</p>
                                    <div v-if="showOptions">
                                        <div v-for="selectedItem in selectedItems" :key="selectedItem.id"
                                            class="text-center " style="color: rgb(0, 132, 255)">
                                            <div class="botoesPrevia" v-if="selectedItem.id === 'QUICK_REPLY'">
                                                <i class="fas fa-reply"></i> {{ selectedItem.textoBotao }}
                                            </div>
                                            <div class="botoesPrevia" v-if="selectedItem.id === 'PHONE_NUMBER'">
                                                <i class="fas fa-phone-alt"></i> {{ selectedItem.textoBotao }}
                                            </div>
                                            <div class="botoesPrevia" v-if="selectedItem.id === 'URL'">
                                                <i class="fas fa-external-link-alt"></i> {{ selectedItem.textoBotao }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-pagination v-model="pagina" :total-rows="total" :per-page="itensPorPagina" align="right" size="md"
                    class="mt-2"></b-pagination>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";
export default {
    name: "ModalModeloMensagem",
    components: {
        RotateSquare
    },
    props: {
        contatoId: {
            type: String,
            default: ""
        },
        telefoneId: {
            type: String,
            default: ""
        },
        evento: {
            type: String,
            default: ""
        },
        primeiraMensagem:{
            type: Boolean,
            default:false
        }
    },
    data() {
        return {
            viewModel: {
                arquivo: null,
                contaId: this.$store.getters.getAutenticacao.contaSelecionadaId
            },
            loading: false,
            abrir: false,
            itens: [],
            pagina: 1,
            total: 0,
            itensPorPagina: 0,
            registroSelecionado: null,
            selectedItems: null,
            showOptions: false,
            optionsBotao: [
                { id: "QUICK_REPLY", label: this.$t("sectionModeloMensagem.botaoQuickReply"), small: this.$t("sectionModeloMensagem.personalizado"), desabilitado: false },
                { id: "PHONE_NUMBER", label: this.$t("sectionModeloMensagem.botaoLigar"), small: this.$t("sectionModeloMensagem.maxBotaoLigar"), desabilitado: false },
                { id: "URL", label: this.$t("sectionModeloMensagem.botaoSite"), small: this.$t("sectionModeloMensagem.maxBotaoSite"), desabilitado: false },
            ],
        };
    },
    computed: {
        fields() {
            return [
                {
                    key: "nomeModelo",
                    label: this.$t("sectionModeloMensagem.nomeModelo"),
                    sortable: false,
                    tdClass: "CustomTd"
                },
                {
                    key: "categoria",
                    label: this.$t("sectionModeloMensagem.categoria"),
                    sortable: false,
                    tdClass: "CustomTd"
                }

            ];
        },
        horaAtual() {
            const agora = new Date();
            const hora = agora.getHours().toString().padStart(2, '0');
            const minuto = agora.getMinutes().toString().padStart(2, '0');
            return `${hora}:${minuto}`;
        },
    },
    watch: {
        pagina: function (val) {
            this.ObterGrid(val);
        }
    },
    methods: {
        Enviar(arquivo) {
            this.$emit(this.evento, arquivo);
            this.abrir = false;
        },
        AbrirModal() {
            this.abrir = true;
            this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId;
            this.ObterGrid(1);
        },
        ObterNomeCategoria(nome) {
            switch (nome) {
                case "MARKETING":
                    return this.$t("sectionModeloMensagem.MARKETING");
                case "UTILITY":
                    return this.$t("sectionModeloMensagem.UTILITY");
                default:
                    return this.$t("textNenhum");
            }
        },
        ObterGrid(pagina) {
            this.loading = true;
            this.$http({
                url:
                    "/modelo-mensagem/obter-grid-envio/" +
                    this.$store.getters.getAutenticacao.contaSelecionadaId +
                    "/" +
                    this.telefoneId +
                    "/" +
                    pagina,
                method: "GET"
            })
                .then((response) => {
                    this.loading = false;
                    this.itens = response.data.itens;
                    this.total = response.data.total;
                    this.pagina = response.data.pagina;
                    this.itensPorPagina = response.data.itensPorPagina;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        selecionarRegistro(registro) {
            this.registroSelecionado = null;
            this.showOptions = false;

            this.registroSelecionado = registro;
            this.viewModel = this.registroSelecionado;
            this.arquivoId = this.registroSelecionado.arquivoId;

            if (this.registroSelecionado.botoes.length > 0) {
                this.showOptions = true;

                this.registroSelecionado.botoes.forEach(element => {
                    const botaoSelecionadoItem = this.optionsBotao.find((item) => item.id === element.id);
                    element.label = botaoSelecionadoItem.label
                });
                this.selectedItems = this.registroSelecionado.botoes;
            }


        },
        EnviarModelo() {
            this.loading = true;
            
            this.$http({
                url:
                    "/modelo-mensagem/enviar-modelo/" +
                    this.$store.getters.getAutenticacao.contaSelecionadaId +
                    "/" +
                    this.telefoneId +
                    "/" +
                    this.contatoId
                    +
                    "/" +
                    this.registroSelecionado.id,
                method: "GET"
            })
                .then((response) => {
                    this.loading = false;
                    this.registroSelecionado = null;
                    this.$emit("send-modelo");
                    this.abrir = false;
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        }
    }
};
</script>
  
<style scoped lang="scss">
.previa {
    flex: 1;
    border: 1px solid #ccc;
    padding: 10px;
    text-align: center;
    box-sizing: border-box;
    background: url("/img/fundoWhats.jfif");
}

.botoesPrevia {
    border-top: 1px solid #929292;
    border-bottom: 1px solid #929292;
    padding: 8px 0;
    text-align: center;
}

.chat-bubble-footer {
    margin: 0;
    font-size: 12px;
    color: #929292;
    word-wrap: break-word;
}

.chat-bubble {
    text-align: left;
    max-width: 100%;
    padding: 10px;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 5px;
    position: relative;
    min-height: 40px;
}

.chat-text {
    margin: 0;
    font-size: 14px;
    color: #000;
    word-wrap: break-word;
}

.chat-image {
    background-color: #d6d6d6;
    color: #000;

    i {
        font-size: 80px;
    }

    img,
    video {
        width: 100%;
        height: 100%;
    }
}

.chat-bubble::before {
    content: "";
    position: absolute;
    left: -20px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
}

.chat-time {
    margin: 5px 0 0 0;
    font-size: 10px;
    color: #aaa;
    /* Cor cinza mais clara para o horário */
    text-align: right;
}
</style>
  